import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import instance from "../../../config/Config"


const initialState = {
    data: null,
    loading: false,
    error: null,
}

export const fetchAllSalesScreen = createAsyncThunk(
    "fetchAllSalesScreen",
    async (body) => {
        try {

            const response = await instance.get(
                `crm/leads/target-goal-screen?filterType=${body?.filterType}`
            );

            return response.data;

        } catch (error) {
            return error?.response;
        }
    }
);

export const SalesReportSlice = createSlice({
    name: "SalesReportSlice",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(fetchAllSalesScreen.pending, (state) => {
            state.loading = true;
            state.data = null;
        });
        builder.addCase(fetchAllSalesScreen.fulfilled, (state, action) => {
            state.loading = false;
            state.data = action.payload;
        });
        builder.addCase(fetchAllSalesScreen.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload?.data;
        });

    }
})

export default SalesReportSlice.reducer;